import * as React from 'react';
import { PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet-async';

interface ISeoProps extends PropsWithChildren {
  title?: string | null;
  description?: string | null;
  image?: string | null;
}

const Seo: React.FC<ISeoProps> = ({ title, description, image, children }) => {
  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      {image ? <meta property="og:image" content={image} /> : null}
      {children}
    </Helmet>
  );
};

export default Seo;
